import React from 'react'

import { useFilter, useLocalityModal } from 'store'
import { Tag } from 'components'
import classNames from 'classnames'

import PropTypes from 'prop-types'
import parseTagSetFilters from './utils'

import styles from './TagSetContainer.module.scss'

/**
 * Renders all or some (tagsDisplay param) filters from store as tags, allowing the user to remove any filter from store by clicking the X on the tag
 * @param {string} props.tagsDisplay Indicates which filter group should be displayed (see PropTypes for options)
 * @param {bollean} props.carrouselMode True to render tag container with overflow X, making it like an X axis infinite scroll
 * @author Leandro Parisi
 * @since 2020.03.12
 */
const TagSetContainer = ({ tagsDisplay, carrouselMode }) => {
  const {
    $filter: {
      selectedLocalities,
      filters,
      valueRange,
      visits,
      noLegalActions,
      noDebts,
      surroundingsSearch,
    },
    removeSelectedLocality,
    toggleFilter,
    setFieldManually,
    setField,
  } = useFilter()

  const { setClickedBy } = useLocalityModal()

  const arrayFilters = { ...filters }

  const toogleFilters = { visits, noLegalActions, noDebts, surroundingsSearch }

  const integerFilters = { valueRange }

  const {
    reconstructedArrayFilters: {
      goal,
      propertyStatus,
      purchaseType,
      propertyType,
      saleType,
      desagio,
    },
    reconstructedToggleFilters: {
      visit,
      legalAction,
      debts,
      surroundingSearch,
    },
    reconstructedIntegerFilters: { reconstructedValueRange },
  } = parseTagSetFilters(arrayFilters, toogleFilters, integerFilters)

  const renderLocalityTags = () => {
    return (
      selectedLocalities &&
      selectedLocalities[0] &&
      selectedLocalities.map((locality, index) => (
        <Tag onClick={() => removeSelectedLocality(index, selectedLocalities)}>
          {locality.name}
        </Tag>
      ))
    )
  }

  const renderArrayFilters = reconstructedFilter => {
    const { currentFilters, field } = reconstructedFilter
    const toggledFilters = currentFilters.filter(filter => filter.checked)
    return toggledFilters.map(({ name, value }) => (
      <Tag onClick={() => toggleFilter(field, value)}>{name}</Tag>
    ))
  }

  const renderToggleFilters = reconstructedFilter => {
    const { status, title, field } = reconstructedFilter
    if (status) {
      return (
        <Tag onClick={value => setFieldManually(field, !value, setClickedBy)}>
          {title}
        </Tag>
      )
    }
    return null
  }

  const renderIntegerFilters = reconstructedFilter => {
    const { title, resetValue, field, show } = reconstructedFilter

    if (show) {
      return <Tag onClick={() => setField(field, resetValue)}>{title}</Tag>
    }
    return null
  }

  return (
    Object.keys(filters).length &&
    tagsDisplay === 'all' && (
      <div
        className={classNames(styles.tagSetContainer, {
          [styles.carrouselMode]: carrouselMode,
        })}
      >
        {renderLocalityTags()}
        {renderToggleFilters(surroundingSearch)}
        {renderArrayFilters(goal)}
        {renderArrayFilters(propertyType)}
        {renderIntegerFilters(reconstructedValueRange)}
        {renderArrayFilters(saleType)}
        {renderArrayFilters(propertyStatus)}
        {renderArrayFilters(purchaseType)}
        {renderToggleFilters(legalAction)}
        {renderToggleFilters(debts)}
        {renderToggleFilters(visit)}
        {renderArrayFilters(desagio)}
      </div>
    )
  )
}

TagSetContainer.propTypes = {
  tagsDisplay: PropTypes.oneOf(['all']),
  carrouselMode: PropTypes.oneOf([true, false]),
}

TagSetContainer.defaultProps = {
  tagsDisplay: 'all',
  carrouselMode: false,
}

export default TagSetContainer
